import { Box, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import PerfomanceSnapShot from './PerfomanceSnapShot';
import KeyMatrixLanding from './KeyMatrixLanding';
import HealthScoreLanding from './HealthScoreLanding';
import { useSelector } from 'react-redux';

const GraphSections = () => {
  const managementDashboard = useSelector((state) => state.dashboard.managementDashboard.data);
  const managementDashboardLoading = useSelector((state) => state.dashboard.managementDashboard.loading);

  /* const perfomanceData = {
    score: 72,
    positive: 12,
    neutral: 22,
    needsAttention: 2,
  }; */

  const keyMetricsData = useMemo(
    () => ({
      title: 'Key Metrics Trend (Last 7 Days)',
      metrics: [
        {
          key: 'revenue',
          label: 'Revenue',
          value: managementDashboard?.keyMetricsTrend?.revenue?.value || 0,
          color: '#26A69A',
          trend: managementDashboard?.keyMetricsTrend?.revenue?.trend?.map((v) => Number(v)),
        },
        {
          key: 'sales',
          label: 'Sales',
          value: managementDashboard?.keyMetricsTrend?.sales?.value || 0,
          color: '#7E57C2',
          trend: managementDashboard?.keyMetricsTrend?.sales?.trend?.map((v) => Number(v)),
        },
        {
          key: 'admissions',
          label: 'Admissions',
          value: managementDashboard?.keyMetricsTrend?.admissions?.value || 0,
          color: '#42A5F5',
          trend: managementDashboard?.keyMetricsTrend?.admissions?.trend?.map((v) => Number(v)),
        },
        {
          key: 'assessments',
          label: 'Assessments',
          value: managementDashboard?.keyMetricsTrend?.assessments?.value || 0,
          color: '#FFA726',
          trend: managementDashboard?.keyMetricsTrend?.assessments?.trend?.map((v) => Number(v)),
        },
      ],
    }),
    [managementDashboard],
  );

  const healthScoreData = {
    score: 75,
    maxScore: 100,
    status: 'Good',
    description: 'Your company is performing well, but there are a few areas that need attention.',
    change: 6,
  };
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              borderRadius: 3,
              transition: '0.2s',
              '&:hover': {
                boxShadow: 6,
              },
              height: { xs: 'auto', md: '350px' },
            }}
          >
            {managementDashboardLoading ? (
              <Skeleton width={'100%'} sx={{ height: '100%', minHeight: 150 }} />
            ) : (
              <PerfomanceSnapShot
                data={
                  managementDashboard?.performanceSnapshot || {
                    score: 0,
                    positive: 0,
                    neutral: 0,
                    needsAttention: 0,
                  }
                }
              />
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              borderRadius: 3,
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              '&:hover': {
                boxShadow: 6,
              },
              height: { xs: 'auto', md: '350px' },
            }}
          >
            {managementDashboardLoading ? (
              <Skeleton width={'100%'} sx={{ height: '100%', minHeight: 150 }} />
            ) : (
              <KeyMatrixLanding keyMetricsData={keyMetricsData} />
            )}
          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={6} lg={4}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              borderRadius: 3,
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              '&:hover': {
                boxShadow: 6,
              },
               height:{xs:'auto',md:'350px'}
            }}
          >
           <HealthScoreLanding data={healthScoreData}/>
          </Paper>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default GraphSections;
